export const mockDeveloperInstanceOptions = [
  { uuid: 'dev12345', name: 'Developer Instance' },
  { uuid: 'staging12345', name: 'Staging Instance' },
  { uuid: 'prod12345', name: 'Prod Instance' },
]
